import React from "react";
import { useState } from "react";
import { AiOutlineGold } from "react-icons/ai";
import {
  MdAccountBalance,
  MdAddchart,
  MdAssessment,
  MdGroup,
  MdInsertChartOutlined,
  MdInsights,
  MdListAlt,
  MdMoney,
  MdOutlineBusinessCenter,
  MdOutlineCalculate,
  MdOutlineCreditCard,
  MdOutlineKeyboardArrowDown,
  MdOutlineSavings,
  MdOutlineSettingsInputSvideo,
  MdOutlineSettingsSuggest,
  MdOutlineShoppingBasket,
  MdPerson,
  MdSearch,
  MdStackedLineChart,
  MdSwapHoriz,
  MdTableChart,
  MdWaterfallChart,
  MdOutlineLinkOff,
  MdAttachMoney,
  MdOutlineCreditScore,
  MdDescription,
  MdOutlineSchool,
  MdTrendingUp,
  MdAddTask,
  MdOutlinePayments,
  MdOutlineSwapHoriz,
} from "react-icons/md";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import { RiQuestionLine } from "react-icons/ri";
import { Link } from "react-router-dom";
import { FadeInDownDiv } from "styledComponents/animation";
import { Tooltip } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { getlocalStorageLogin } from "common/components/apiConfig";
import ChartIcon from "common/components/svg/chart";
import Payments from "common/components/svg/payments";
import PishkhanIcon from "common/components/svg/pishkhan";
import ProfileIcon from "common/components/svg/profile";
import ReportsIcon from "common/components/svg/reports";
import { BsCashStack } from "react-icons/bs";
import { useLocation } from "react-router-dom";
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";
import { TbBuildingWarehouse } from "react-icons/tb";

const useStyles = makeStyles((theme) => ({
  tooltip: {
    maxWidth: 350,
    fontSize: 12,
    padding: 12,
    marginInline: 32,
  },
}));

const ListMenu = ({ open, setopen }) => {
  const classes = useStyles();

  const [click, setclick] = useState("");
  const [clickChild, setclickChild] = useState(null);
  const [flagFlash, setflagFlash] = useState(false);
  let pathname = useLocation().pathname;
  const isMobile = window.innerWidth < 768;
  const coveredCallPermissions = [
    "0015761843",
    "0067327451",
    "2560071721",
    "0079824171",
    "0079824171",
    "0016626631",
    "0071761391",
    "0016094530",
    "1288344198",
    "0069985677",
    "0532417763",
    "0016626631",
    "0079678920",
    "0019192967",
    "1250462932",
    "0022893938",
  ];
  // const hasPermissionsList = ["0016094530", "0079678920", "0016626631"];
  const tradePermissions = ["0374833117", "0022893938", "0016094530"];
  const goldCreditPermissions = [
    "0022893938",
    "2560071721",
    "0079824171",
    "0019192967",
    "0012909718",
    "0015761843",
    "0080888747",
    "2298042888",
    "2280462222",
    "2720510874",
    "1816945481",
    "1461704601",
    "0322717061",
  ];
  const permission = (nationalIdList) => {
    const adminObj = getlocalStorageLogin();

    if (adminObj) {
      const userObject = adminObj?.user;
      const nationalId = userObject?.member_national_id;
      // const nationalId = adminObj?.user?.member_national_id;

      const havepermission = nationalIdList?.filter(
        (item) => `${item}` === nationalId,
      );
      return havepermission.length;
    }
  };

  let data = [
    {
      icon: <ProfileIcon />,
      title: "پروفایل",
      route: "/profile",
    },
    {
      icon: <MdOutlineLinkOff />,
      title: "سفارشات آفلاین",
      route: "/offline-order",
    },
    {
      icon: <MdAddTask />,
      title: "واریز وجه",
      route: "/deposit",
    },
    {
      icon: <Payments />,
      title: "تقاضای وجه",
      route: "/payments",
      // type: 'disabled'
    },
    {
      icon: <ReportsIcon />,
      title: "دارایی ( پرتفوی )",
      route: "/reports",
    },
  ];
  // const adminObj = getlocalStorageLogin();
  // const userObject = adminObj?.user;
  // const nationalId = userObject?.member_national_id;
  // const hasPermission = hasPermissionsList.includes(nationalId);
  const asadi = ["0016094530", "1272475077", "1272937909", "0022893938"];
  const asadiSaveMoney = [
    "0016094530",
    "0019192967",
    "1450965164",
    "0074722506",
    "0253328993",
    "0022893938",
  ];

  const handleClick = (list, ind) => {
    if (list.child) {
      if (ind === click) {
        setclickChild(null);
        setflagFlash((prev) => !prev);
      } else {
        setclickChild(null);
        setflagFlash(true);
      }
    }
    if (!list.child) {
      setflagFlash(false);
      setclickChild(null);
      setopen(false);
    }
    setclick(ind);
  };
  const handleClickChild = (list, ind) => {
    setclickChild(ind);
    setopen(false);
  };
  if (!permission(["1450965164", "0015761843", "0073496774", "0022893938"])) {
    data = data
      .map((item) => {
        if (item.route === "/marketmaking") {
          return {
            ...item,
            child: item.child
              ? item.child.filter(
                  (childItem) => childItem.route !== "/marketmaking",
                )
              : item.child,
          };
        }
        return item;
      })
      .filter((item) => item.route !== "/marketmaking");
  }
  if (!permission(["1450965164", "0015761843", "0022893938"])) {
    data = data
      .map((item) => {
        if (item.route === "/marketmaking") {
          return {
            ...item,
            child: item.child
              ? item.child.filter(
                  (childItem) => childItem.route !== "/marketmaking-algorithm",
                )
              : item.child,
          };
        }
        return item;
      })
      .filter((item) => item.route !== "/marketmaking-algorithm");
  }
  return (
    <>
      <div className="flex flex-col mt-2  w-full overflow-y-auto max-h-[450px] md:max-h-full ">
        {data?.map((list, ind) => {
          if (
            list.title === "پایش استراتژی" &&
            !permission(coveredCallPermissions)
          )
            return "";
          if (list.title === "معاملات" && !permission(tradePermissions))
            return "";
          if (list.title === "سبد گردانی" && !permission(asadi)) return "";
          // if (
          //   list.title === "سفارشات آفلاین" &&
          //   !permission([
          //     "0016094530",
          //     "1450965164",
          //     "0022893938",
          //     "0015761843",
          //   ])
          // )
          // return;
          // if (
          //   list.title === "واریز وجه" &&
          //   !permission(["0015761843", "0024277185", "0022893938"])
          // )
          //   return "";
          if (
            list.title === "بورس کالا و آتی" &&
            !permission(["0015761843", "0024277185", "0022893938"])
          )
            return "";
          if (list.title === "پس انداز دوره ای" && !permission(asadiSaveMoney))
            return "";
          if (
            list.title === "بازاریابی" &&
            !permission([
              "0016094530",
              "0480959838",
              "1450965164",
              "3050814721",
              "1361576510",
              "0022893938",
            ])
          )
            return "";

          return (
            <div key={ind}>
              <Link
                to={list.type === "disabled" ? "/home" : list.route}
                className={`w-full flex items-center justify-center relative mb-2`}
                onClick={() => handleClick(list, ind)}
              >
                <div
                  className={`items-center px-4 ${
                    pathname === list.route && open && !list.type
                      ? "bg-surface"
                      : click === ind && open && !list.type
                        ? "bg-surface"
                        : ""
                  } flex w-full rounded-md ${
                    !open ? "" : "py-2 px-1"
                  } transition-all `}
                >
                  {list.type === "disabled" ? (
                    <div
                      className={`text-xl  ${
                        pathname === list.route ? "text-primary" : "text-black"
                      } ${
                        !open && pathname === list.route
                          ? "bg-surface rounded-md p-2"
                          : !open
                            ? "p-2"
                            : "ml-1"
                      } transition-all text-gray-300`}
                    >
                      {list.icon}
                    </div>
                  ) : (
                    <div
                      className={`text-xl  ${
                        pathname === list.route || click === ind
                          ? ""
                          : "text-black"
                      } ${
                        pathname === list.route && !open
                          ? "bg-surface rounded-md p-2"
                          : !open
                            ? "p-2"
                            : "ml-1"
                      } transition-all`}
                    >
                      {isMobile ? null : (
                        <Tooltip
                          className="mt-1"
                          title={<p className="p-2 mr-4">{list.title}</p>}
                          placement="left-end"
                          arrow
                          classes={{ tooltip: classes.tooltip }}
                        >
                          <h1>{list.icon}</h1>
                        </Tooltip>
                      )}
                    </div>
                  )}

                  {open && (
                    <>
                      {list.type === "disabled" ? (
                        <div
                          className={"text-gray-300"}
                          style={{ fontSize: 14 }}
                        >
                          {list.title}
                        </div>
                      ) : (
                        <div
                          className={
                            pathname === list.route || click === ind
                              ? "text-primary font-medium transition-all"
                              : ""
                          }
                          style={{ fontSize: 14 }}
                        >
                          {list.title}
                        </div>
                      )}
                    </>
                  )}
                  {list.child && (
                    <div className="mr-auto ml-2">
                      {click === ind && flagFlash ? (
                        <MdOutlineKeyboardArrowDown className="transition-all rotate-0" />
                      ) : (
                        <MdOutlineKeyboardArrowDown className="transition-all -rotate-180" />
                      )}
                    </div>
                  )}
                </div>
              </Link>
              {list.child && (
                <>
                  {flagFlash && ind === click ? (
                    <FadeInDownDiv>
                      {list.child.map((itm, ind2) => (
                        <Link
                          to={itm.route}
                          className={`${
                            !open ? "pr-3" : "pr-12"
                          } flex w-full items-center  relative mb-3 text-sm `}
                          key={ind2}
                          onClick={() => handleClickChild(list, ind2)}
                        >
                          <div
                            className={`text-base ml-2 ${!open ? "pr-3" : ""} ${
                              clickChild === ind2
                                ? "text-primary"
                                : "text-gray-400"
                            }`}
                          >
                            {itm.icon}
                          </div>
                          {open && (
                            <div
                              className={
                                clickChild === ind2
                                  ? "text-primary"
                                  : "text-xs text-gray-400"
                              }
                            >
                              {itm.title}
                            </div>
                          )}
                        </Link>
                      ))}
                    </FadeInDownDiv>
                  ) : (
                    ""
                  )}
                </>
              )}
            </div>
          );
        })}
      </div>
    </>
  );
};

export default React.memo(ListMenu);
